export enum PaymentMethodType {
  BANK_CARD = 'raiffeisen',
  YANDEX_PAY = 'yandex_pay',
  YANDEX_SPLIT = 'yandex_split'
}

export enum YandexPayType {
  SPLIT = 'SPLIT',
  CARD = 'CARD'
}
